import { render } from "./ui-table-filter.vue?vue&type=template&id=22d3efb1&scoped=true&ts=true"
import script from "./ui-table-filter.vue?vue&type=script&lang=ts"
export * from "./ui-table-filter.vue?vue&type=script&lang=ts"

import "./ui-table-filter.vue?vue&type=style&index=0&id=22d3efb1&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d3efb1"]])

export default __exports__